import { render, staticRenderFns } from "./CommentThread.vue?vue&type=template&id=ffd3423c&scoped=true"
import script from "./CommentThread.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentThread.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommentThread.vue?vue&type=style&index=0&id=ffd3423c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd3423c",
  null
  
)

export default component.exports